<style scoped>

</style>

<template>
  <div class="upload-image-component">
    <input v-if="!singleImage" ref="upload-image" type="file" @change="uploadImage" style="display:none" multiple accept="image/x-png,image/jpeg"/>
    <input v-else ref="upload-image" type="file" @change="uploadImage" style="display:none" accept="image/png,image/jpeg"/>
  </div>
</template>

<script>
  import ImageCompressor from 'image-compressor.js';

  export default {
    name: 'UploadImageComponent',
    props: {
      singleImage: Boolean, required: false, default: false
    },
    mounted() {
    },
    methods: {
      triggerUpload(){
        // reset file every upload
        const input = this.$refs['upload-image'];
        input.type = 'text';
        input.type = 'file';
        // reset file every upload
        this.$refs['upload-image'].click()
      },

      uploadImage(e){
        let files = e.target.files || e.dataTransfer.files;
        if (!files.length)
          return;

        let results = []
        let reader = new FileReader();
        let i = 0;

        this.$store.commit('publicModule/setImageUploadLoader', true);

        console.log(files[i])
        compressImage(files[i])
        // reader.readAsDataURL(files[i]);

        reader.onload = (e) => {
          results.push(e.target.result)
        };

        reader.onloadend = (a, b) => {
          i++;
          if (i < files.length) {
            console.log(files[i])
            compressImage(files[i]);
            // reader.readAsDataURL(files[i]);
          } else {
            this.$emit('emitBase64', results)
          }
        }

        function compressImage (file) {
          new ImageCompressor(file, {
            quality: .9,
            success(result) {
              console.log(result)
              reader.readAsDataURL(result);
            },
            error(e) {
              console.log(e.message);
            },
          });
        }
      }
    }
  }
</script>
